import { notifyEvent } from "./notifyEvent";

export const saveUser = (user, profile) => {
  window.user = { ...user, ...profile };
  window.localStorage.setItem("user", JSON.stringify(user));
  notifyEvent({ name: "userProfile", detail: user });
};
